import { Popover, PopoverBody } from "reactstrap";
import { useRef, useState } from "react";

interface InfoPopoverProps {
    heading: string;
    content: string;
    size?: number | string;
}

export default function InfoPopover({ heading, content, size = 20 }: InfoPopoverProps) {
    const [open, setOpen] = useState(false);
    const iconRef = useRef<HTMLSpanElement>(null);

    const toggle = () => setOpen(prev => !prev);

        return (
            <>
            {/* Icon (Target Element) */}
            <span
                ref={iconRef}
                role="button"
                onClick={toggle}
                className="d-inline-flex align-items-center justify-content-center text-muted"
                style={{ cursor: "pointer" }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20" fill="none">
                    <path d="M9.16797 14.1663H10.8346V9.16626H9.16797V14.1663ZM10.0013 7.49959C10.2374 7.49959 10.4355 7.41959 10.5955 7.25959C10.7555 7.09959 10.8352 6.90182 10.8346 6.66626C10.8341 6.4307 10.7541 6.23293 10.5946 6.07293C10.4352 5.91293 10.2374 5.83293 10.0013 5.83293C9.76519 5.83293 9.56741 5.91293 9.40797 6.07293C9.24853 6.23293 9.16852 6.4307 9.16797 6.66626C9.16741 6.90182 9.24741 7.09987 9.40797 7.26043C9.56852 7.42098 9.7663 7.5007 10.0013 7.49959ZM10.0013 18.3329C8.84853 18.3329 7.76519 18.114 6.7513 17.6763C5.73741 17.2385 4.85547 16.6449 4.10547 15.8954C3.35547 15.146 2.76186 14.264 2.32464 13.2496C1.88741 12.2351 1.66853 11.1518 1.66797 9.99959C1.66741 8.84737 1.8863 7.76404 2.32464 6.74959C2.76297 5.73515 3.35658 4.8532 4.10547 4.10376C4.85436 3.35432 5.7363 2.7607 6.7513 2.32293C7.7663 1.88515 8.84964 1.66626 10.0013 1.66626C11.153 1.66626 12.2363 1.88515 13.2513 2.32293C14.2663 2.7607 15.1482 3.35432 15.8971 4.10376C16.646 4.8532 17.2399 5.73515 17.6788 6.74959C18.1177 7.76404 18.3363 8.84737 18.3346 9.99959C18.333 11.1518 18.1141 12.2351 17.678 13.2496C17.2419 14.264 16.6482 15.146 15.8971 15.8954C15.146 16.6449 14.2641 17.2388 13.2513 17.6771C12.2385 18.1154 11.1552 18.334 10.0013 18.3329ZM10.0013 16.6663C11.8624 16.6663 13.4388 16.0204 14.7305 14.7288C16.0221 13.4371 16.668 11.8607 16.668 9.99959C16.668 8.13848 16.0221 6.56209 14.7305 5.27043C13.4388 3.97876 11.8624 3.33293 10.0013 3.33293C8.14019 3.33293 6.5638 3.97876 5.27214 5.27043C3.98047 6.56209 3.33464 8.13848 3.33464 9.99959C3.33464 11.8607 3.98047 13.4371 5.27214 14.7288C6.5638 16.0204 8.14019 16.6663 10.0013 16.6663Z" fill="#7A7A7A" />
                </svg>
            </span>

            {/* Popover */}
            <Popover
                isOpen={open}
                target={iconRef}
                toggle={toggle}
                placement="right"
                trigger="legacy"
                fade={false}
            >
                <PopoverBody className="p-3" style={{ maxWidth: "320px" }}>
                    <div className="fw-semibold mb-1">{heading}</div>
                    <div className="text-muted">{content}</div>
                </PopoverBody>
            </Popover>
        </>
    );
}
